import gql from 'graphql-tag';

const query = gql`
  query DailyTracker($date: Date!) {
    me {
      diet {
        id
        accessTo
      }
      aiAccess {
        hasAccess
      }
    }

    dailyTracker {
      data(date: $date) {
        id
        date
        baseCalories
        trainingCalories
        totalCalories
        consumedCalories
        remainingCalories
        macroSource
        isGoalAchieved
        isAvailable
        macros {
          protein {
            targetGrams
            targetPercentage
            consumedGrams
            remainingGrams
          }
          fat {
            targetGrams
            targetPercentage
            consumedGrams
            remainingGrams
          }
          carbs {
            targetGrams
            targetPercentage
            consumedGrams
            remainingGrams
          }
          fiber {
            targetGrams
            targetPercentage
            consumedGrams
            remainingGrams
          }
        }
        events {
          ... on SimpleDailyTrackerActivity {
            id
            activityName: name
            activityTypeName
            caloriesBurned
            durationSeconds
            distance
            distanceUnit
            imageUrl
            loggedAt
            activitySourceType: sourceType
            deviceName
            isComposite
            badges
          }
          ... on SimpleDailyTrackerMeal {
            id
            name
            calories
            proteinGrams
            carbsGrams
            fatGrams
            fiberGrams
            portions
            imageUrl
            mealType
            loggedAt
            sourceType
          }
          ... on DailyTrackerMealWithProducts {
            id
            name
            calories
            proteinGrams
            carbsGrams
            fatGrams
            fiberGrams
            portions
            imageUrl
            mealType
            loggedAt
            sourceType
            products {
              id
              name
              calories
              proteinGrams
              carbsGrams
              fatGrams
              baseAmount
              baseUnit
            }
          }
        }
      }
    }
  }
`;

export default query;
